exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-dropdown-panel .ng-select-multiple .ng-select-bottom {\n  position: relative !important; }\n\n.divTime1 {\n  background-color: white;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  border: 1px solid #ccc;\n  color: #555; }\n\n.divTime2 {\n  background-color: white;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  color: #555; }\n\n.inputTime {\n  border: none;\n  color: #555;\n  text-align: center;\n  width: 60px; }\n\n.tooltip1 {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black; }\n\n.tooltip1 .tiptext {\n  visibility: hidden;\n  width: 160px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 3px;\n  padding: 6px 0;\n  position: absolute;\n  z-index: 1;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2); }\n\n.tooltip1:hover .tiptext {\n  visibility: visible; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/panel-control/panel-control.component.scss
// module id = ../../../../../src/app/admin/panel-control/panel-control.component.scss
// module chunks = panel-control.module